/**
 * 从来源页面 URL 中取域名用于列表展示（客户按站点区分会话）；非法 URL 原样返回
 */
export const formatPageHost = (url: string) => {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
};
